import { transformRevenueStatementToTableData } from './transformRevenueStatementToTableData';

export { transformRevenueStatementToTableData };
